<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8mAdkD/tc-custom/9781480484153.jpg?1717877921002" alt="This image is the cover for the book Count of Monte Cristo"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Count of Monte Cristo
      </h1>
      <p class="bookDescription body article font2">
        <b>An epic adventure and one of the most enduring fables in Western literature</b><br/><br/>Edmond Dantés has a life that any man would envy. A promising young sailor about to be made a captain, he has come home to Marseille to marry his beautiful fiancée, Mercédès. But on the eve of his wedding, Dantés is betrayed, accused of treason, and sentenced without trial to life in prison. For the first six years, Dantés can only mourn his stolen future and dwell on the treachery that landed him behind bars. On the verge of suicide, he meets a fellow prisoner who gives him not just an education in revenge, but the means to accomplish it, as well. After an ingenious escape, Dantés recovers a hidden treasure and returns to Marseille as the Count of Monte Cristo, a man whose unlimited resources are matched only by his boundless thirst for vengeance.<br/><br/>An illuminating portrait of early nineteenth-century France and a timeless tale of justice achieved, <i>The Count of Monte Cristo </i>has inspired numerous adaptations, from comic books and Broadway plays to the hit TV series <i>Revenge</i>.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alexandre  Dumas
      </h2>
      
      <p class="authorDescription body article"> Alexandre Dumas (1802&ndash;1870) was the son of Thomas-Alexandre Dumas, a hero of Revolutionary France and the first black <I>g&eacute;n&eacute;ral d&rsquo;arm&eacute;e</I>. A popular playwright and novelist, Alexandre Dumas is best remembered today as the author of <I>The Count of Monte Cristo</I> and <I>The Three Musketeers</I>. His son, also named Alexandre Dumas, wrote the tragic love story <I>Camille</I>.&#160; </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01be3b42